import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ServicePage from './pages/ServicePage';
import Loader from './components/Loader';
import MobileStyles from './components/MobileStyles';

export default function App() {
  const [loaded, setLoaded] = useState(false);
  return (
    <>
      <MobileStyles />
      {!loaded && <Loader onDone={() => setLoaded(true)} />}
      <div style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.6s ease' }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServicePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}
